import Cookies from 'js-cookie';
import { urlBackNestApp } from '../routes/urls';

let defaultHeaders = {
  'Content-Type': 'application/json',
  Authorization: `Bearer ${Cookies.get('careflowToken')}`,
};

function getDefaultHeaders() {
  if (defaultHeaders.Authorization == 'Bearer null') {
    defaultHeaders.Authorization = `Bearer ${Cookies.get('careflowToken')}`;
  }
  return defaultHeaders;
}

async function get<T>(
  path: string,
  args: RequestInit = { method: 'GET', headers: getDefaultHeaders() }
): Promise<T> {
  const response = await fetch(path, args);
  return response.json();
}

async function post<T>(
  path: string,
  body: any,
  args: RequestInit = {
    method: 'POST',
    body: JSON.stringify(body),
    headers: getDefaultHeaders(),
  }
): Promise<T> {
  const response = await fetch(path, args);
  return response.json();
}

async function put<T>(
  path: string,
  body: any,
  args: RequestInit = {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: getDefaultHeaders(),
  }
): Promise<T> {
  const response = await fetch(path, args);
  return response.json();
}

async function patch<T>(
  path: string,
  body: any,
  args: RequestInit = {
    method: 'PATCH',
    body: JSON.stringify(body),
    headers: getDefaultHeaders(),
  }
): Promise<T> {
  const response = await fetch(path, args);
  return response.json();
}

const User = {
  getAllUsers: () => get<any>(`${urlBackNestApp}/user/getUsers`),
  getRecord: (id: any) => get<any>(`${urlBackNestApp}/user/workflow?id=${id}`),
  customUpdate: (data: any) => put<any>(`${urlBackNestApp}/user/workflow`, data),
  getUserSessionsRedirectUrl: () => get<any>(`${urlBackNestApp}/auth/user-sessions`),
};

const Workflow = {
  getWorkflowByCode: (code: any) => get<any>(`${urlBackNestApp}/workflow/?code=${code}`),
  getTransitions: (workFlow: any) =>
    get<any>(`${urlBackNestApp}/workflow/transitions?workFlow=${workFlow}`),
  getInstance: (referenceId: any, referenceName: any) =>
    get<any>(
      `${urlBackNestApp}/workflow/instance/?referenceName=${referenceName}&referenceId=${referenceId}`
    ),
  dbAttribute: (data: any) =>
    post<any>(`${urlBackNestApp}/workflow/instance/dbattribute`, data),
  assignOwner: (data: any) =>
    post<any>(`${urlBackNestApp}/workflow/instance/assignOwner`, data),
  reAssignOwner: (data: any) =>
      post<any>(`${urlBackNestApp}/workflow/instance/reAssignOwner`, data),
  fhirAttribute: (data: any) =>
    post<any>(`${urlBackNestApp}/workflow/instance/fhirattribute`, data),
  updateWorkflowInstance: (data: any) =>
    put<any>(`${urlBackNestApp}/workflow/instance/update`, data)
};

const Record = {
  updateRecordByAttribute: (data: any) =>
    put<any>(`${urlBackNestApp}/workflow/instance/`, data),
};

const Checklist = {
  getChecklistById: (data: any) => post<any>(`${urlBackNestApp}/checklist/allChecklist`, data),
  markItemCompleted: (data: any) => post<any>(`${urlBackNestApp}/checklist/completed`, data),
  getChecklistByCode: (code: any) => get<any>(`${urlBackNestApp}/checklist/code/?code=${code}`),
  checkItemsValid: (data: any) => post<any>(`${urlBackNestApp}/checklist/checkItemsValid`, data),
};

const Transition = {
  attempt: (data: any) => post<any>(`${urlBackNestApp}/transition/attempt/`, data),
  updateStage: (data: any) => put<any>(`${urlBackNestApp}/transition/stage/`, data),
};

const Activity = {
  getActivities: () => get<any>(`${urlBackNestApp}/ccm/activity/activities`),
};

const Catalog = {
  getCatalogByCode: (code: any) => get<any>(`${urlBackNestApp}/crs/catalog/?code=${code}`)
};

const defaultConsts = {
  User,
  Workflow,
  Checklist,
  Transition,
  Record,
  Activity,
  Catalog,
};

export default defaultConsts;
